import Button from '@/atoms/Button/Button';
import React from 'react'
import MapModal from './MapModal';
import { analytics, getExploreMap } from '@/utils/analytics';
import Text from '@/atoms/Text/Text';

function MapWestholme({ fields, entries, assets }) {
  const [mapIsOpen, setMapIsOpen] = React.useState(false);

  const handleMapOpen = (e) => {
    analytics({
      window,
      document,
      detail: getExploreMap(e, { linkText: fields?.previewCtaText }),
    });
    setMapIsOpen(true);
  };

  const handleMapClose = (e) => {
    // TODO: analytics
    setMapIsOpen(false);
  };

  React.useEffect(() => {
    document.body.style.overflow = mapIsOpen ? 'hidden' : 'unset';

    return () => (document.body.style.overflow = 'unset');
  }, [mapIsOpen]);

  return (
    <div className="relative md:p-0 pb-4">
      <Button
        style="aaco-cta__primary-wh p-0 hover:bg-leucadendron text-black cursor-pointer px-2 py-1 md:px-4 md:py-2"
        onClick={handleMapOpen}
      >
        <Text tag="body" style="!font-text">
          {fields?.previewCtaText}
        </Text>
      </Button>
      <MapModal
        open={mapIsOpen}
        closeModal={handleMapClose}
        fields={fields}
        assets={assets}
        entries={entries}
      />
    </div>
  )
}

export default MapWestholme
